import { ChoiceQuizState } from './choiceQuiz.types';

export const initialQuizState: ChoiceQuizState = {
  answers: {},
  isSubmitted: false,
  isQuizPassed: false,
  isEveryQuestionCorrect: false,
  feedback: [],
};

export const quizOffset: number = 200;
